import { gql } from "@apollo/client";

const VNPAY_CREATE_PAYMENT = gql`
  mutation VnpayCreatePayment($input: VnpayCreatePaymentInput!) {
    vnpayCreatePayment(input: $input) {
      url
    }
  }
`;

export default VNPAY_CREATE_PAYMENT;
